module.exports = __webpack_public_path__ + "static/img/gz-img02.edad879.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gz-img02.png
// module id = btOA
// module chunks = 1